import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const Maintenance = ({ startDate, endDate }) => {
  const formatTime = (date) => {
    if (!date) return '';
    const utcTime = moment.utc(date).format('DD-MM-YYYY HH:mm');
    const localTime = moment.utc(date).local().format('HH:mm');
    return `${utcTime} UTC (${localTime} local)`;
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#f5f6fa',
        textAlign: 'center',
      }}
    >
      <h1 style={{ color: '#2d3436' }}>Site Under Maintenance</h1>
      <p style={{ color: '#636e72', fontSize: '1.2rem' }}>
        We are currently performing scheduled maintenance.
        <br />
        Please try again later.
      </p>
      {startDate && endDate && (
        <p style={{ color: '#636e72', marginTop: '1rem' }}>
          Maintenance window:
          <br />
          <strong>{formatTime(startDate)}</strong>
          <br />
          to
          <br />
          <strong>{formatTime(endDate)}</strong>
        </p>
      )}
      <span role="img" aria-label="tools" style={{ fontSize: '3rem', marginTop: '1rem' }}>
        🛠️
      </span>
    </div>
  );
};

Maintenance.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

export default Maintenance;
